import Vue from 'vue'
import Router from 'vue-router'
//一级路由
import Login from './components/Login'//登录
import Home from './components/Home' //首页
import GI from './components/GI' //地理信息
import Monitoring from './components/Monitoring'//运行监控
import ProjectManage from './components/ProjectManage' //项目管理
import Management from './components/Management' //运维管理
import AssetsManagement from './components/AssetsManagement' //资产管理
import Setting from './components/Setting' //系统设置
import Undefined from './components/err/404'//错误页面
//二级路由
import LampStatistics from './components/03Monitoring/1_lamp/statistics'//运行监控-01智慧照明-统计概览
import LampHistory from './components/03Monitoring/1_lamp/history'//运行监控-01智慧照明-历史记录
import LampManagement from './components/03Monitoring/1_lamp/equipment_management'//运行监控-01智慧照明-设备管理
import EnvironmentStatistics from './components/03Monitoring/2_environment/statistics'//运行监控-02环境监测-统计概览
import EnvironmentHistory from './components/03Monitoring/2_environment/history'//运行监控-02环境监测-历史记录
import EnvironmentManagement from './components/03Monitoring/2_environment/equipment_management'//运行监控-02环境监测-设备管理
import ProtectionMonitoring from './components/03Monitoring/3_protection/monitoring'//运行监控-03智慧安防-安防监控
import ProtectionVideo from './components/03Monitoring/3_protection/video_list'//运行监控-03智慧安防-视频管理
import WifiStatistics from './components/03Monitoring/4_wifi/statistics'//运行监控-04无线WIFI-统计概览
import WifiEarnings from './components/03Monitoring/4_wifi/earnings'//运行监控-04无线WIFI-收益分析
import WifiAdManagement from './components/03Monitoring/4_wifi/advertising_management'//运行监控-04无线WIFI-广告主管理
import MsgStatistics from './components/03Monitoring/5_msg/statistics'//运行监控-05信息发布-统计概览
import MsgLED_resource from './components/03Monitoring/5_msg/LED_resource'//运行监控-05信息发布-LED媒体资源
import MsgEvent_managing from './components/03Monitoring/5_msg/event_managing'//运行监控-05信息发布-节目管理
import MsgEvent_managing_add from './components/03Monitoring/5_msg/event_managing_add'//运行监控-05信息发布-节目管理-添加
import MsgEvent_managing_fix from './components/03Monitoring/5_msg/event_managing_fix'//运行监控-05信息发布-节目管理-编辑
import MsgLED_management from './components/03Monitoring/5_msg/LED_management'//运行监控-05信息发布-LED屏幕管理
import MsgLED_main_ad from './components/03Monitoring/5_msg/main_ad'//运行监控-05信息发布-主广告管理
import LoudspeakerStatistics from './components/03Monitoring/6_loudspeaker/statistics'//运行监控-06智能音箱-统计概览
import LoudspeakerEvent_managing from './components/03Monitoring/6_loudspeaker/event_managing'//运行监控-06智能音箱-节目管理
import LoudspeakerManagement from './components/03Monitoring/6_loudspeaker/equipment_management'//运行监控-06智能音箱-设备管理
import LoudspeakerTemporary_duty from './components/03Monitoring/6_loudspeaker/temporary_duty'//运行监控-06智能音箱-临时任务
import LoudspeakerAdvertising from './components/03Monitoring/6_loudspeaker/advertising'//运行监控-06智能音箱-广告主管理

import AlarmManagement from './components/03Monitoring/7_alarm/equipment_management'//运行监控-07一键报警-设备管理
import Charging_pileTodayStatistics from './components/03Monitoring/8_chargingpile/TodayStatistics'//运行监控-08充电桩-今日汇总
import Charging_pileStatistics from './components/03Monitoring/8_chargingpile/statistics'//运行监控-08充电桩-数据统计
import RFID from './components/03Monitoring/9_RFID/RFID_monitor'//运行监控-09RFID监测
import Null from './components/03Monitoring/null' //空页面

import basicInfo from './components/Setting/basic_info'  //密码修改
import passwordUpdate from './components/Setting/password_update'  //密码修改
import userManage from './components/Setting/user_manage'  //用户管理
import roleManage from './components/Setting/role_manage'  //角色管理


import Operation from './components/05Management/1_operation'
import Equipment from './components/05Management/2_equipment'
import Breakdown from './components/05Management/3_breakdown'
import News from './components/05Management/4_news'
import Log from './components/Setting/log'


Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:[
    {path:'/',name:'login',component:Login},
    {path:'/Home',name:'home',component:Home},
    {path:'/GI',name:'geographic_information',component:GI},
    {path:'/monitoring',name:'monitoring',component:Monitoring,redirect:'/monitoring/ProtectionMonitoring',children:[
        {path:'/monitoring/LampStatistics',name:'LampStatistics',component:LampStatistics},
        {path:'/monitoring/LampHistory',name:'LampHistory',component:LampHistory},
        {path:'/monitoring/LampManagement',name:'LampManagement',component:LampManagement},
        {path:'/monitoring/EnvironmentStatistics',name:'EnvironmentStatistics',component:EnvironmentStatistics},
        {path:'/monitoring/EnvironmentHistory',name:'EnvironmentHistory',component:EnvironmentHistory},
        {path:'/monitoring/EnvironmentManagement',name:'EnvironmentManagement',component:EnvironmentManagement},
        {path:'/monitoring/ProtectionMonitoring',name:'ProtectionMonitoring',component:ProtectionMonitoring},
        {path:'/monitoring/ProtectionVideo',name:'ProtectionVideo',component:ProtectionVideo},
        {path:'/monitoring/WifiStatistics',name:'WifiStatistics',component:WifiStatistics},
        {path:'/monitoring/WifiEarnings',name:'WifiEarnings',component:WifiEarnings},
        {path:'/monitoring/WifiAdManagement',name:'WifiAdManagement',component:WifiAdManagement},
        {path:'/monitoring/MsgStatistics',name:'MsgStatistics',component:MsgStatistics},
        {path:'/monitoring/MsgLED_management',name:'MsgLED_management',component:MsgLED_management},
        {path:'/monitoring/MsgEvent_managing',name:'MsgEvent_managing',component:MsgEvent_managing},

        {path:'/monitoring/MsgEvent_managing_add',name:'MsgEvent_managing_add',component:MsgEvent_managing_add},
        {path:'/monitoring/MsgEvent_managing_fix',name:'MsgEvent_managing_fix',component:MsgEvent_managing_fix},

        {path:'/monitoring/MsgLED_resource',name:'MsgLED_resource',component:MsgLED_resource},
        {path:'/monitoring/MsgLED_main_ad',name:'MsgLED_main_ad',component:MsgLED_main_ad},
        {path:'/monitoring/LoudspeakerStatistics',name:'LoudspeakerStatistics',component:LoudspeakerStatistics},
        {path:'/monitoring/LoudspeakerEvent_managing',name:'LoudspeakerEvent_managing',component:LoudspeakerEvent_managing},
        {path:'/monitoring/LoudspeakerManagement',name:'LoudspeakerManagement',component:LoudspeakerManagement},
        {path:'/monitoring/LoudspeakerTemporary_duty',name:'LoudspeakerTemporary_duty',component:LoudspeakerTemporary_duty},
        {path:'/monitoring/LoudspeakerAdvertising',name:'LoudspeakerAdvertising',component:LoudspeakerAdvertising},
        {path:'/monitoring/AlarmManagement',name:'AlarmManagement',component:AlarmManagement},
        {path:'/monitoring/Charging_pileTodayStatistics',name:'Charging_pileTodayStatistics',component:Charging_pileTodayStatistics},
        {path:'/monitoring/Charging_pileStatistics',name:'Charging_pileStatistics',component:Charging_pileStatistics},
        {path:'/monitoring/RFID',name:'RFID',component:RFID},
        {path:'/monitoring/null',name:'Null',component:Null},
      ]
    },
    {path:'/ProjectManage',name:'project_manage',component:ProjectManage},
    {path:'/management',name:'management',component:Management,redirect:'/management/Operation',children:[
        {path:'/management/Operation',name:'Operation',component:Operation},
        {path:'/management/Equipment',name:'Equipment',component:Equipment},
        {path:'/management/Breakdown',name:'Breakdown',component:Breakdown},
        {path:'/management/News',name:'News',component:News},
      ]},
    {path:'/AssetsManagement',name:'AssetsManagement',component:AssetsManagement},
    {path:'/Setting',name:'Setting',component:Setting,redirect:'/setting/basicInfo',children:[
        {path:'/setting/basicInfo',name:'basicInfo',component:basicInfo},
        {path:'/setting/passwordUpdate',name:'passwordUpdate',component:passwordUpdate},
        {path:'/setting/userManage',name:'userManage',component:userManage},
        {path:'/setting/roleManage',name:'roleManage',component:roleManage},
        {path:'/setting/Log',name:'Log',component:Log},
      ]},
    // {path:'*',component:Undefined}
  ]
})
//全局守卫
// router.beforeEach((to,from,next)=>{
//   if (to.path === '/') {
//     next();
//   } else {
//     let token = localStorage.getItem('eleToken');

//     if (token === null || token === '' || token === undefined) {
//       next('/');
//     } else {
//       next();
//     }
//   }
// });

export default router;



// WEBPACK FOOTER //
// ./src/routes.js